<template>
  <div class="data-panel">
    <h3 class="data-title">Chamados de Suporte</h3>
    <div v-if="supportLoading" style="color:#6b7280;font-size:14px;">Carregando...</div>
    <div v-else-if="supportTickets.length === 0" style="color:#9ca3af;font-size:14px;">Nenhum chamado de suporte.</div>
    <div v-else class="log-scroll">
      <table class="admin-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Título</th>
            <th>Solicitante</th>
            <th>Status</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="st in supportTickets" :key="st.id">
            <td>{{ formatDate(st.createdAt) }}</td>
            <td>{{ st.title }}</td>
            <td><code>{{ st.requestedByUsername }}</code></td>
            <td><span :class="st.status === 'resolvido' ? 'badge-ok' : 'badge-pending'">{{ st.status }}</span></td>
            <td>
              <button v-if="st.status !== 'resolvido'" class="btn-table-action" @click="resolveSupportTicket(st.id)">Resolver</button>
              <span v-else style="color:#9ca3af;font-size:12px;">{{ formatDate(st.resolvedAt) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, inject, onMounted } from 'vue'
import { masterFetch } from '@/store/masterSession'

interface SupportTicket {
  id: string
  systemId: string
  title: string
  message: string
  status: string
  requestedByUsername: string
  resolvedBy: string
  resolvedAt: string
  resolutionNotes: string
  createdAt: string
}

export default {
  name: 'AdminSysSupportTab',
  setup() {
    const detail = inject<any>('adminDetail')

    const supportTickets = ref<SupportTicket[]>([])
    const supportLoading = ref(false)

    const loadSupport = async () => {
      if (!detail?.value) return
      supportLoading.value = true
      try {
        const sysId = detail.value.systemId
        const all = await masterFetch<SupportTicket[]>('/master/support-tickets')
        supportTickets.value = all.filter((t: SupportTicket) => t.systemId === sysId)
      } catch { /* ignore */ } finally {
        supportLoading.value = false
      }
    }

    onMounted(loadSupport)

    const formatDate = (d: string) => {
      if (!d) return ''
      try { return new Date(d).toLocaleDateString('pt-BR') } catch { return d }
    }

    const resolveSupportTicket = async (id: string) => {
      try {
        await masterFetch(`/master/support-tickets/${id}/resolve`, { method: 'PUT', body: JSON.stringify({ resolutionNotes: '' }) })
        const t = supportTickets.value.find((x: SupportTicket) => x.id === id)
        if (t) { t.status = 'resolvido'; t.resolvedAt = new Date().toISOString() }
      } catch { /* ignore */ }
    }

    return { supportTickets, supportLoading, formatDate, resolveSupportTicket }
  }
}
</script>

<style lang="scss">
.log-scroll { overflow-x: auto; }

.badge-ok {
  background: #dcfce7;
  color: #166534;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
}

.badge-fail {
  background: #fef2f2;
  color: #dc2626;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
}

.badge-pending {
  background: #fef3c7;
  color: #92400e;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
}

.btn-table-action {
  background: #0f4c81;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: #0d3d6a; }
}
</style>
